export enum AuthoritySupplier {
  REGISTER_SUPPLIER_ACTIVE_DEACTIVE = '1.4.7',
  REGISTER_SUPPLIER_IMPORT = '1.4.6',
  REGISTER_SUPPLIER_REPORT_SUPPLIERS = '1.4.5',
  REGISTER_SUPPLIER_EDIT = '1.4.4',
  REGISTER_SUPPLIER_DELETE = '1.4.3',
  REGISTER_SUPPLIER_ADD = '1.4.2',
  REGISTER_SUPPLIER_VIEW = '1.4.1',
  REGISTER_SUPPLIER_REGISTRATION = '1.4',
}
